import Button from "../../Button";
import { t } from "i18next";
import React, { FC, useContext, useEffect, useState } from "react";
import "./Cookies.scss";
import { getCurrentLanguage } from '../../../i18n';
import NavContext from '../Nav/NavProvider';
import { getSectionSlug, YouplanetSections } from "../../../constants/general";

type CookiesProps = {
  defaultHidden?: boolean;
};

export const cookieName = "user_cookie_consent";
const Cookies: FC<CookiesProps> = ({ defaultHidden }) => {
  const { acceptCookies } = useContext(NavContext);
  const [isOpened, setIsOpened] = useState(null);

  function onAcceptCookies(hideComponent?: boolean) {
    deleteCookie();
    setCookie();

    if (!hideComponent) {
      setIsOpened(false);
    }
  };

  function setCookie() {
    const d = new Date();
    const exdays = 30;

    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    document.cookie = `${cookieName}=1;expires=${d.toUTCString()};path=/`;
  }

  function deleteCookie() {
    removeCooke(cookieName);
  }

  function removeCooke(cookieName: string) {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000);

    document.cookie = `${cookieName}=;expires=${d.toUTCString()};path=/`;
  }

  function getCookies() {
    const cookie = document.cookie.includes(`${cookieName}=1`);

    if (!cookie && !isOpened) {
      setIsOpened(true);
    }
  }

  useEffect(() => {
    if(!defaultHidden) {
      getCookies();
    }
  }, [])
  
  useEffect(() => {
    if (acceptCookies) {
      onAcceptCookies(true);
    }
    if (acceptCookies === false) {
      deleteCookie();
    }
  }, [acceptCookies])
  
  return (
    <div className={`cookies ${isOpened === false ? "is-hidden" : ""} ${isOpened ? 'is-open' : ''}`}>
      <span className="cookies__text">
        {t("common.cookieText")}
        <a className='cookies__link' href={getSectionSlug(YouplanetSections.Legal, getCurrentLanguage())}>
          {t("common.cookieLinkText")} </a>
      </span>
      <Button solid uppercase clickHandler={() => onAcceptCookies()}>
        {t("common.accept")}
      </Button>
    </div>
  );
};

export default Cookies;
